import React from 'react'
import type { ReactNode } from 'react'
import { isEmailValid } from '@mobi/account/Utils/validation'
import { CustomerServiceTelephone } from '@mobi/component-library/Base/Link'

export function isPhoneNumberValid(phone: string) {
  const phoneValidation = /^0[0-8]\d{8}$/
  return phoneValidation.test(phone)
}

export function getEmailError(email: string) {
  let error: string | false = false
  error = !isEmailValid(email) ? 'Please enter a valid email address' : false
  return error
}

export function getMobileError(mobile: string) {
  let error: string | false = false
  error = !isPhoneNumberValid(mobile) ? 'Please enter a valid Australian mobile number' : false
  return error
}

export const duplicateEmailErrorMessage: ReactNode = (
  <span>
    We've encountered an error. Please try a different email address or call{' '}
    <CustomerServiceTelephone /> for assistance
  </span>
)

export const duplicateMobileErrorMessage: ReactNode = (
  <span>
    We've encountered an error. Please try a different mobile number or call{' '}
    <CustomerServiceTelephone /> for assistance
  </span>
)
